export const getBusinessProfileUrl = () => '/business/business_profiles';
